import "@kenshooui/react-multi-select/dist/style.css";
import React, { useState, useEffect, useRef } from "react";
import MultiSelect from "@kenshooui/react-multi-select";
import { fetchJson } from "../../lib/Fetching";

export default function ProductSearch({ company_id, company_branch_id, onChange }) {
  const [items, setItems] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const fetcher = useRef(null);

  const preload = company_id != null;

  useEffect(() => {
    setItems([]);
    setSelectedItems([]);
    if (preload) {
      fetchProducts();
    }
  }, [company_id, company_branch_id]);

  const fetchProducts = search => {
    if (fetcher.current) {
      clearTimeout(fetcher.current);
    }
    fetcher.current = setTimeout(() => {
      fetchJson("/products/api/products.json", {
        company_id,
        company_branch_id,
        search
      }).then(products =>
        setItems(
          products.map(p => ({
            id: p.id,
            label: p.name
          }))
        )
      );
    }, 300);
    return item => true;
  };

  const filterItems = value => {
    if (preload) {
      return item =>
        String(item.label)
          .toLowerCase()
          .includes(value.toLowerCase());
    } else {
      return fetchProducts(value);
    }
  };

  return (
    <MultiSelect
      key={[company_id, company_branch_id]}
      itemHeight={25}
      selectAllHeight={30}
      items={items}
      selectedItems={selectedItems}
      onChange={items => {
        setSelectedItems(items);
        onChange(items.map(i => i.id));
      }}
      filterFunction={filterItems}
      height={200}
      responsiveHeight={"200px"}
    />
  );
}
